import {Component, OnInit, ViewChild} from '@angular/core';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {MessagingService} from '../../service/messaging.service';

@Component({
  selector: 'app-error-handler',
  templateUrl: './error-handler.component.html',
  styleUrls: ['./error-handler.component.scss']
})
export class ErrorHandlerComponent implements OnInit {

  public message;
  public messageObserver;
  public messageTitleObserver;
  public presetMessage;

  @ViewChild('content') private content;

  constructor(public msgModal: NgbModal,
              public msgService: MessagingService) {
  }

  ngOnInit() {

    this.messageTitleObserver = this.msgService.modalTitleSubject
      .subscribe((result) => {
        this.presetMessage = result;
      });

    this.messageObserver = this.msgService.messageSubject
      .subscribe((result) => {
        this.message = {};
        if (result !== null) {
          switch (result.status) {
            case 0:
              this.message.status = 'alert';
              this.message.content = 'Invalid credentials';
              break;
            case 200:
              this.message.status = 'success'
              if (this.message !== undefined && this.message !== null) {
                this.message.content = JSON.parse(result._body)['message'];
              } else {
                this.message.content = this.presetMessage + ' successful!';
              }
              break;
            case 400:
            case 401:
            case 403:
            case 404:
            case 422:
              this.message.status = 'alert';
              this.message.content = 
                JSON.parse(result._body)['message'] ||
                JSON.parse(result._body)['error'];
              break;
            default:
              this.message.status = 'alert';
              this.message.content = 'Unknown error'
              break;
          }
          if (this.message.content === undefined) {
            this.message.content = 'Success!';
          }
          this.msgModal.open(this.content, {windowClass: 'animated-modal'});
        }

      });


  }

}



// WEBPACK FOOTER //
// ./src/app/modal-edit/error-handler/error-handler.component.ts